/**
 * AGNT, Inc. wordmark — the official "AGNT" brand mark.
 *
 * A standalone, reusable element so the header, hero, and footer all share one
 * source of truth for the brand mark. Sized by height via CSS (`width: auto`)
 * by each caller. The asset is a white PNG, used only on AGNT's dark navy
 * surfaces (header nav, home hero, footer).
 */

// White wordmark in public/. Drop the file here to update the brand mark.
const LOGO_SRC = '/next/assets/images/agnt-inc/AGNT_Typeset_White.png';

export interface AgntLogoProps {
  /** Class for sizing (sets height; width is auto). */
  className?: string;
  /** Accessible label. Defaults to "AGNT, Inc.". */
  title?: string;
}

export default function AgntLogo({ className, title = 'AGNT, Inc.' }: AgntLogoProps) {
  // Plain <img>, not next/image: a small static brand asset reused across the
  // header/hero/footer, sized by height via `className` (so `width: auto` keeps
  // the PNG's aspect ratio).
  // eslint-disable-next-line @next/next/no-img-element
  return <img className={className} src={LOGO_SRC} alt={title} />;
}
